import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import util from '../../lib/util';

import Top from '../navigation/top';
import Autocomplete from '../form/autocomplete';
import { FormRow } from '../form/formField';

const initialState = {};

const FIELDS = {
    id: { label: 'Db #', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    title: { label: 'title', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    alias: { label: 'alias', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    source: { label: 'source', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    tags: { label: 'tags', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    url: { label: 'url', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    clicks: { label: 'clicks', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    created: { label: 'created', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    updated: { label: 'updated', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    updatedDate: { label: 'Updated date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
};

@observer
class UrlEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };
        this.updateTimer = {};
        const { urlStore } = this.props.stores;
        urlStore.load(props.id);

        this.fields = [
            {
                tabname: 'Basics',
                icon: 'fas fa-user-edit',
                fields: ['id', 'title', 'alias', 'source', 'tags', 'url', 'clicks', 'created', 'updated', 'updatedDate'].map(f => util.makeField(f, FIELDS)),
            },
        ];
    }

    updateField = async (id, field, value) => {
        const { urlStore } = this.props.stores;
        urlStore.updateField(id, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { urlStore } = this.props.stores;
        await urlStore.saveField(id, field, value);
    }

    render(props) {
        const { urlStore } = this.props.stores;
        const { url, saved } = urlStore;

        let tabIdx = this.fields.findIndex(e => e.tabname === props.tabname);
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return (
            <div>
                <Top {...props} />

                <div class='row'>
                    <div class='col-12'>
                        <div class='d-flex flex-row bd-highlight mb-3'>
                            <div>
                                <a href='/urls' class={`mr-2 btn btn-sm btn-warning`}>
                                    <i class={`fas fa-arrow-left mr-1`} />
                                    Back
                                </a>
                            </div>
                            <div>
                                <h4>Edit: {url.id}: {url.title}</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-12'>
                        <ul class='nav nav-tabs mb-2'>
                            {this.fields.map(tab => (
                                <li class='nav-item'>
                                    <a class={`nav-link ${props.tabname === tab.tabname ? 'active' : ''}`}
                                        href={`/urls/${props.urlid}/${tab.tabname}`}
                                    >
                                        <i class={`${tab.icon} mr-2`} />
                                        {tab.tabname}
                                    </a>
                                </li>
                            ))}
                        </ul>

                        {this.fields[tabIdx].fields.map(field => <FormRow
                            field={field}
                            object={url}
                            saved={saved}
                            updateField={this.updateField}
                        />)}

                    </div>
                </div>
            </div>
        );
    }
}

export default UrlEdit;



// WEBPACK FOOTER //
// ./components/urls/edit.js